import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import CommonIn from '../utils/CommonIn';
import noticeData from '../data/NoticeData';
// import './common.css';
// import './dreamt1.css';
// import './aos.css';
// import $ from 'jquery';
// import AOS from 'aos';
// import 'aos/dist/aos.css';

const NoticeView = () => {
  const [searchParams] = useSearchParams();  
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    // AOS.init();
    CommonIn();
    const getNumberFromQueryString = () => {
      const numberParam = searchParams.get('no');
      const number = parseInt(numberParam, 10);
      return isNaN(number) ? null : number;
    };

    const number = getNumberFromQueryString();
    if (number && noticeData[number - 1]) {
      setNotice(noticeData[number - 1]);
    }
  }, [searchParams]);

  const nextNotice = () => {
    const number = parseInt(searchParams.get('no'), 10);
    if (number < noticeData.length) {
      window.location.href = `./noticeview?no=${number + 1}`;
    } else {
      alert('다음글이 없습니다.');
    }
  };

  const prevNotice = () => {
    const number = parseInt(searchParams.get('no'), 10);
    if (number > 1) {
      window.location.href = `./noticeview?no=${number - 1}`;
    } else {
      alert('이전글이 없습니다.');
    }
  };

  const stringToHtml = (str) => {
    const number = parseInt(searchParams.get('no'), 10);
    const strHrml = str.split('<br/>');
    return (
      <ul>
        {strHrml.map(el => {
          return <li key={number+"_"+Math.random()}>{el}</li>;
        })}
      </ul>
   ); 
    
  }

  if (!notice) {
    return <div>Loading...</div>;
  }

  return (
     
      <main className="submain" id="submain">
        <section>
          <div className="container">
            <article className="notice-view-wrapper">
              <h3 className="notice-view-title">{notice.title}</h3>
              <p className="notice-view-date">{notice.date}</p>
              <hr />
              <div className="notice-view-body">{stringToHtml(notice.text)}</div>
            </article>
            <div className="notice-view-footer">
              <button onClick={() => (window.location.href = './notice')}>목록으로 가기</button>
              <div className="notice-view-next-btn">
                <button onClick={prevNotice}>이전글</button>
                <button onClick={nextNotice}>다음글</button>
              </div>
            </div>
          </div>
        </section>
      </main>
  );
};

export default NoticeView;